import React from 'react';
import {
    TextField,
    MenuItem
} from 'material-ui';

export const InputSelectField = (props) => {
    const {
        input,
        label,
        options,
        id,
        fullWidth,
        helperText,
        InputLabelProps,
        className,
        meta: {touched, error}
    } = props;

    let selectItem = options.map((option, index) => 
        <MenuItem key={'item_' + index} value={option.id} className={className}>{option.display_name}</MenuItem>
    )

    return (
        <div>
            <TextField
                select
                id={id}
                label={label}
                fullWidth={fullWidth}
                helperText={helperText}
                InputLabelProps={InputLabelProps}
                margin="normal"
                value={input.value || 0}
                error={touched && error ? true : false}
                className={className}
                {...input}
            >
                {id !== "select-block-type" ? <MenuItem key={0} value={0} className={className}> None </MenuItem> : ''}
                {selectItem}
            </TextField>
            <br />
            {touched && error && <span className="errMsg"> {error} </span>}
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/fields/field_input_select_blocks.js